import { useNavigate } from "react-router-dom";
import React from "react";
import Error404Header from "../error404-header/Error404Header";

function Back() {
  const navigate = useNavigate();

  return (
    <>
    
      <input
        type="button"
        className=""
        value="Back"
        onClick={() => navigate(-1)}
      />
    </>
  );
}
export default Back;
